module.exports = __webpack_public_path__ + "static/img/innovation.b5c63233.png";